import { View, Text, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import GlobalStyles from './../style';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants'

let lang = undefined;

const MainMenu = () => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
        headerShown: false,
        headerTitle: "Header..."
    })
  }, []);

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
    })
  }
  readValue()

  const language = useSelector((state) => state.language);
  lang = dr.idiomas[language ? language : 0].value

  return (
    <View style={{flex:1,flexDirection: "column"}}>
      <View style={{ flex: 1}}>
        <View style={{ marginHorizontal:25, marginBottom: 'auto', marginTop: 'auto'}}>
          <View style={[GlobalStyles.buttonMargins]}>
            <Pressable
              disabled={!value}
              style={!value ? GlobalStyles.buttonStartDisabled : GlobalStyles.buttonStart}
              onPress={() => navigation.navigate('HomeScreen')}>
              <Text style={GlobalStyles.textForButtonMain}>{transl('MainMenu.continuar',lang)}</Text>
            </Pressable>
          </View>
          <View style={[GlobalStyles.buttonMargins]}>
            <Pressable
              style={GlobalStyles.buttonStart}
              onPress={() => navigation.navigate('NewGame')}>
              <Text style={GlobalStyles.textForButtonMain}>{transl('MainMenu.nuevaPartida',lang)}</Text>
            </Pressable>
          </View>
        </View>
        <View style={[GlobalStyles.centerHorizontally, {marginBottom: 25}]}>
            <Text>Versión {Constants.expoConfig?.version}</Text>
          </View>
      </View>
    </View>
  )
}

export default MainMenu